global.modules.set({
  async init(context) {
    function initRepeaterRows(repeater) {
      $(repeater).find('.repeater_row').each(function () {
        initRepeaterRow(this, repeater);
      })
    }

    function initRepeaterRow(row, repeater) {
      $(row).find('.row_remove').on('click', function () {
        $(repeater).trigger('remove_row');
        $(this).closest('.repeater_row').remove();
        $(repeater).find('.repeater_row').each(function (index) {
          $(this)
            .find('[name]').each(function () {
              $(this).removeAttr('disabled')
                .attr('name', $(this).attr('name').split(new RegExp('\[[1-9]+\]')).join(`[${index}]`));
            })
        })
      })
    }

    $('.repeater', context).each(function () {
      var repeater = $(this)
      this.template = repeater.find('.repeater_template').children().clone().get()[0];
      repeater.find('.repeater_template').remove();
      initRepeaterRows(repeater);
      repeater.find('.add_row').on('click', function () {
        var rows = repeater.find('.rows');
        var maxItems = repeater.attr('max_items');
        var rowsCount = rows.children().length;
        if(maxItems && maxItems <= rowsCount) {
          global.showNotificationPopup('Max number of files reached');
          return;
        }
        var row = $(repeater.get()[0].template).clone();
        rows.append(row);
        row.find('[name]').each(function () {
          $(this)
            .removeAttr('disabled')
            .attr('name', $(this).attr('name').split('[]').join(`[${rowsCount}]`));
        })
        initRepeaterRow(row);
        repeater.trigger('add_row');
      });
    });
  }
})